/**
 * Set only when navigating to the add-mobile screen with a server-provided number
 * to display. Consumed once on that screen then removed — avoids stale `phone` OTP data.
 */
export const SESSION_PHONE_MOBILE_INPUT_PREFILL = "phone_mobile_input_prefill";
